// src/hooks/useContextIntegration.js - Updated for Zustand
import { useEffect, useRef } from 'react';
import { useGamificationStore } from '../stores/gamificationStore';
import { useApp } from '../context/AppContext';

export const useContextIntegration = () => {
  // With Zustand, we don't need the whole context - just get the store reference
  const gamificationStore = useGamificationStore.getState();
  const { completedModules, completedTools } = useApp();
  const isSetupRef = useRef(false);
  const lastSyncRef = useRef({ modules: 0, tools: 0 });

  // Set the global store reference (for backward compatibility if needed)
  useEffect(() => {
    if (gamificationStore && !isSetupRef.current) {
      window.__vibeGamificationStore__ = useGamificationStore;
      isSetupRef.current = true;
    }
  }, []); // Only run once on mount

  // TEMPORARILY DISABLED: Always keep the global reference updated
  // useEffect(() => {
  //   if (gamificationContext) {
  //     window.__vibeGamificationContext__ = gamificationContext;
  //   }
  // }, [gamificationContext]);

  // TEMPORARILY DISABLED: Sync when module data changes - causing infinite re-renders
  // useEffect(() => {
  //   if (gamificationContext && isSetupRef.current && completedModules) {
  //     const currentModuleCount = completedModules.length;
  //     
  //     // Only sync if the count actually changed
  //     if (currentModuleCount !== lastSyncRef.current.modules) {
  //       console.log('🔄 Module count changed, syncing:', {
  //         from: lastSyncRef.current.modules,
  //         to: currentModuleCount,
  //         modules: completedModules,
  //       });
  //       
  //       lastSyncRef.current.modules = currentModuleCount;
  //     }
  //   }
  // }, [gamificationContext, completedModules?.length]);

  // TEMPORARILY DISABLED: Tool sync - causing infinite re-renders
  // useEffect(() => {
  //   if (gamificationContext && isSetupRef.current && completedTools) {
  //     const currentToolCount = completedTools.length;
  //     
  //     if (currentToolCount !== lastSyncRef.current.tools && currentToolCount > 0) {
  //       console.log('🔧 Tool count changed, syncing:', currentToolCount);
  //       
  //       lastSyncRef.current.tools = currentToolCount;
  //     }
  //   }
  // }, [gamificationContext, completedTools?.length]);

  // Debug: Log global context status (DISABLED - was causing refresh issues)
  useEffect(() => {
    // Only run debug check once on mount, not every 5 seconds
    if (import.meta.env.MODE === 'development') {
      if (window.__vibeGamificationContext__) {
        // console.log('🔍 Global context check - SUCCESS:', {
        //   hasContext: !!window.__vibeGamificationContext__,
        //   completedModules: window.__vibeGamificationContext__.completedModules?.length || 0,
        //   totalXP: window.__vibeGamificationContext__.totalXP || 0,
        // });
      } else {
        // console.warn('🔍 Global context check - MISSING');
      }
    }
    
    // DISABLED: Aggressive debug interval causing page refresh issues
    // const interval = setInterval(() => {
    //   if (window.__vibeGamificationContext__) {
    //     console.log('🔍 Global context check - SUCCESS:', {
    //       hasContext: !!window.__vibeGamificationContext__,
    //       completedModules: window.__vibeGamificationContext__.completedModules?.length || 0,
    //       totalXP: window.__vibeGamificationContext__.totalXP || 0
    //     });
    //   } else {
    //     console.warn('🔍 Global context check - MISSING');
    //   }
    // }, 5000);

    // return () => clearInterval(interval);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (window.__vibeGamificationContext__) {
        // console.log('🧹 Cleaning up global gamification context');
        delete window.__vibeGamificationContext__;
      }
    };
  }, []);

  // Return integration status for debugging
  return {
    isReady: isSetupRef.current,
    hasGlobalStore: !!window.__vibeGamificationStore__,
    modulesSynced: lastSyncRef.current.modules,
    toolsSynced: lastSyncRef.current.tools,
    completedModulesFromApp: completedModules?.length || 0,
    completedModulesFromGamification: gamificationStore?.completedModules?.length || 0,
  };
};

export default useContextIntegration;